import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { EmployeeArea } from '../entities/employee-area';

@Injectable()
export class EmployeeAreaService extends BaseCrudService<EmployeeArea> {

  public uri = '/api/employeeArea/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EmployeeAreaService');
  }

  buildSentence(entity?: EmployeeArea, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.row ?
          `row${QueryOperator.Equal}${entity.row}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isCurrent ?
          `isCurrent${QueryOperator.Equal}${entity.isCurrent}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.startDate ?
          `startDate${QueryOperator.Equal}${entity.startDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.endDate ?
          `endDate${QueryOperator.Equal}${entity.endDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.capNumber ?
          `capNumber${QueryOperator.Equal}${entity.capNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isDisability ?
          `isDisability${QueryOperator.Equal}${entity.isDisability}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.procBusiness ?
          `procBusiness${QueryOperator.Equal}${entity.procBusiness}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.destBusiness ?
          `destBusiness${QueryOperator.Equal}${entity.destBusiness}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.officeNumber ?
          `officeNumber${QueryOperator.Equal}${entity.officeNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.comment ?
          `comment${QueryOperator.Equal}${entity.comment}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.accountNumber ?
          `accountNumber${QueryOperator.Equal}${entity.accountNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isUnion ?
          `isUnion${QueryOperator.Equal}${entity.isUnion}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.cciNumber ?
          `cciNumber${QueryOperator.Equal}${entity.cciNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.disabilityComment ?
          `disabilityComment${QueryOperator.Equal}${entity.disabilityComment}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.disabilityDocument ?
          `disabilityDocument${QueryOperator.Equal}${entity.disabilityDocument}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.disabilityDocumentDate ?
          `disabilityDocumentDate${QueryOperator.Equal}${entity.disabilityDocumentDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.ctsAccountNumber ?
          `ctsAccountNumber${QueryOperator.Equal}${entity.ctsAccountNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.ctsCciNumber ?
          `ctsCciNumber${QueryOperator.Equal}${entity.ctsCciNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      if (entity.fiscalYear && entity.fiscalYear.id) {
        query = query.concat(
          `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
        );
      }
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      if (entity.costCenter && entity.costCenter.id) {
        query = query.concat(
          `costCenter.id${QueryOperator.Equal}${entity.costCenter.id}${QueryOperator.Split}`
        );
      }
      if (entity.bank && entity.bank.id) {
        query = query.concat(
          `bank.id${QueryOperator.Equal}${entity.bank.id}${QueryOperator.Split}`
        );
      }
      if (entity.fundingSource && entity.fundingSource.id) {
        query = query.concat(
          `fundingSource.id${QueryOperator.Equal}${entity.fundingSource.id}${QueryOperator.Split}`
        );
      }
      if (entity.accountType && entity.accountType.id) {
        query = query.concat(
          `accountType.id${QueryOperator.Equal}${entity.accountType.id}${QueryOperator.Split}`
        );
      }
      if (entity.employeeContract && entity.employeeContract.id) {
        query = query.concat(
          `employeeContract.id${QueryOperator.Equal}${entity.employeeContract.id}${QueryOperator.Split}`
        );
      }
      if (entity.programmaticStructure && entity.programmaticStructure.id) {
        query = query.concat(
          `programmaticStructure.id${QueryOperator.Equal}${entity.programmaticStructure.id}${QueryOperator.Split}`
        );
      }
      if (entity.costCenterDesignation && entity.costCenterDesignation.id) {
        query = query.concat(
          `costCenterDesignation.id${QueryOperator.Equal}${entity.costCenterDesignation.id}${QueryOperator.Split}`
        );
      }
      if (entity.jobTitle && entity.jobTitle.id) {
        query = query.concat(
          `jobTitle.id${QueryOperator.Equal}${entity.jobTitle.id}${QueryOperator.Split}`
        );
      }
      if (entity.occupationList && entity.occupationList.id) {
        query = query.concat(
          `occupationList.id${QueryOperator.Equal}${entity.occupationList.id}${QueryOperator.Split}`
        );
      }
      if (entity.pfcType && entity.pfcType.id) {
        query = query.concat(
          `pfcType.id${QueryOperator.Equal}${entity.pfcType.id}${QueryOperator.Split}`
        );
      }
      if (entity.officeType && entity.officeType.id) {
        query = query.concat(
          `officeType.id${QueryOperator.Equal}${entity.officeType.id}${QueryOperator.Split}`
        );
      }
      if (entity.shiftingList && entity.shiftingList.id) {
        query = query.concat(
          `shiftingList.id${QueryOperator.Equal}${entity.shiftingList.id}${QueryOperator.Split}`
        );
      }
      if (entity.poiBody && entity.poiBody.id) {
        query = query.concat(
          `poiBody.id${QueryOperator.Equal}${entity.poiBody.id}${QueryOperator.Split}`
        );
      }
      if (entity.paymentType && entity.paymentType.id) {
        query = query.concat(
          `paymentType.id${QueryOperator.Equal}${entity.paymentType.id}${QueryOperator.Split}`
        );
      }
      if (entity.frequencyType && entity.frequencyType.id) {
        query = query.concat(
          `frequencyType.id${QueryOperator.Equal}${entity.frequencyType.id}${QueryOperator.Split}`
        );
      }
      if (entity.disabilityType && entity.disabilityType.id) {
        query = query.concat(
          `disabilityType.id${QueryOperator.Equal}${entity.disabilityType.id}${QueryOperator.Split}`
        );
      }
      if (entity.ctsBank && entity.ctsBank.id) {
        query = query.concat(
          `ctsBank.id${QueryOperator.Equal}${entity.ctsBank.id}${QueryOperator.Split}`
        );
      }
      if (entity.ctsCurrencyType && entity.ctsCurrencyType.id) {
        query = query.concat(
          `ctsCurrencyType.id${QueryOperator.Equal}${entity.ctsCurrencyType.id}${QueryOperator.Split}`
        );
      }
      if (entity.currencyType && entity.currencyType.id) {
        query = query.concat(
          `currencyType.id${QueryOperator.Equal}${entity.currencyType.id}${QueryOperator.Split}`
        );
      }
      if (entity.office && entity.office.id) {
        query = query.concat(
          `office.id${QueryOperator.Equal}${entity.office.id}${QueryOperator.Split}`
        );
      }
     //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'startDate');
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/employee-area.service.ts